import React from "react";
import { Link } from "react-router-dom";
import { products } from "../../App/Landing/landingContent";
import { Icon } from "./Icon";
import Reveal from "./Reveal";
import useProductPricing from "./useProductPricing";

const base = process.env.REACT_APP_PublicPath;

export default function ProductsSection() {
  const pricing = useProductPricing(products.map((p) => p.match));

  return (
    <section id="products" className="bg-brand-mist py-14 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-slate-500">Our print products</p>
          <h2 className="display mt-2 text-3xl sm:text-4xl">Pick What You Need. Make It Yours.</h2>
          <p className="mt-2 text-sm text-slate-500">Durable materials. Vibrant colors. Custom sizes. All in one place.</p>
        </Reveal>

        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {products.map((p, i) => {
            const info = pricing[p.match];
            return (
            <Reveal
              key={p.title}
              as="article"
              delay={i * 130}
              className={`group flex flex-col overflow-hidden transition duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_36px_rgba(11,95,255,.16)] rounded-2xl bg-white shadow-[0_6px_24px_rgba(11,95,255,.08)] ${
                i === 2 ? "md:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="overflow-hidden">
                <img
                  src={p.image}
                  alt={p.alt}
                  width={800}
                  height={480}
                  loading="lazy"
                  className="h-48 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="text-lg font-bold">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-700 leading-relaxed line-clamp-2" title={p.description}>{p.description}</p>
                <ul className="mt-4 space-y-2 text-sm text-slate-700">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-center gap-2">
                      <Icon name="check" className="h-4 w-4 shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto flex items-end justify-between gap-3 pt-6">
                  <p className="shrink-0 text-sm leading-tight text-slate-500">
                    Starting at<br /><span className="mt-1 inline-block text-xl font-bold text-ink">{info?.startingPrice != null ? `$${info.startingPrice.toFixed(2)}` : "—"}</span>
                  </p>
                  {info ? (
                    <Link
                      to={`${base}/banner/${info.productTypeId}`}
                      className="mt-2 inline-flex items-center justify-center gap-2 rounded-full border border-brand px-5 py-2.5 text-sm font-semibold text-brand hover:bg-brand hover:text-white transition-colors"
                    >
                      {p.cta} <Icon name="arrow" className="h-5 w-5 shrink-0" />
                    </Link>
                  ) : (
                    <span className="mt-2 inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-semibold text-slate-400">
                      {p.cta} <Icon name="arrow" className="h-5 w-5 shrink-0" />
                    </span>
                  )}
                </div>
              </div>
            </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
